import React, { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { FindScreen } from './FindScreen';
import { FIND_KINDS, type SearchableTargetKind } from './findKinds';

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The route `/outreach/find?song=&kind=` (design outreach c1). `?s4a=<catalogItemUuid>` (the link of
 * the E6 reminder email) opens the Spotify for Artists helper of that song at once.
 */
const FindViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const [searchParams, setSearchParams] = useSearchParams();
  const s4aParam = searchParams.get('s4a');
  const s4aSong = s4aParam !== null && UUID_PATTERN.test(s4aParam) ? s4aParam : null;
  const closeS4a = useCallback(() => {
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete('s4a');
        return next;
      },
      { replace: true }
    );
  }, [setSearchParams]);
  if (accountId === null) {
    return <LoadingView />;
  }
  const kindParam = searchParams.get('kind');
  const kind: SearchableTargetKind = FIND_KINDS.find((item) => item === kindParam) ?? 'playlist';
  return (
    <FindScreen
      accountId={accountId}
      initialSong={searchParams.get('song') ?? s4aSong}
      initialKind={kind}
      s4aSong={s4aSong}
      onS4aClose={closeS4a}
    />
  );
};

export const FindView = TypedMemo(FindViewComponent);
